// import React from "react";

// import "./index.css";
// import Popup1 from "../../Components/HotelPopups/Popup1";
// export default function HomePageSearchBar() {
//   return (
//     <div className="container-const">
//       <div className="construction-sign">
//         <div className="crane"></div>
//      <Popup1 />
//       </div>
//     </div>
//   );
// }

import React from 'react';
import { useNavigate } from 'react-router-dom';


function HomePageSearchBar() {

  let navigate = useNavigate();
  return (
    <>
    <div style={{background:"white" , padding:"20px" , width : "100%", color: "blue", textAlign: "center", textDecoration: "underline", cursor: "pointer"}} onClick={() => navigate("/hotels/listing")}> Click here to Redirect "Result Page".</div>
    </>
  )
}

export default HomePageSearchBar